import styled, { css } from 'styled-components';

export const ColorCards = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    margin-top: 24px;
    max-width: 672px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 8px;
      justify-content: center;
      margin-top: 24px;
    }
  `}
`;

export const ColorCard = styled.div`
  ${({ theme, background, custom }) => css`
    background: ${background};
    border-radius: 48px;
    cursor: pointer;
    height: 48px;
    justify-content: center;
    position: relative;
    width: 48px;

    ${custom && css`
      align-items: center;
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      display: inline-flex;
      justify-content: center;
    `}
  `}
`;

export const SelectedColorFeedback = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;
`;

export const IconCheckWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: #fff;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 50%;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  `}
`;

export const InputCustomColor = styled.input`
  appearance: none;
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const WrapperColorPicker = styled.div`
  ${({ theme }) => css`
    left: 0;
    position: absolute;
    top: 100%;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      left: 50%;
      transform: translateX(-50%);
    }
  `}
`;
